import type { DocumentTypeConfig } from "./types";

export const DOCUMENT_TYPE_DATA: Record<string, DocumentTypeConfig> = {
    maintenance_manuals: {
        field: "metadata.content_type",
        label: "Document Type",
        types: [
            { value: "Document", count: 2999 },
            { value: "Part Cleaning and inspection (PCI)", count: 2638 },
            { value: "Repair Schemes", count: 2434 },
            { value: "Modification", count: 656 },
            { value: "Overhaul Information Alerts (OIA)", count: 459 },
            { value: "job_cards", count: 279 },
            { value: "Product Advisory Bulletin", count: 226 },
            { value: "Drawings", count: 200 },
            { value: "Illustration", count: 200 },
            { value: "Overhaul Supplementary Information (OSI)", count: 199 },
            { value: "Service Technical Instruction", count: 199 },
            { value: "Operation, Maintenance, Storage and Disposal Manual (OMSD)", count: 197 },
            { value: "Standard Practice Repairs", count: 161 },
            { value: "TSD594J", count: 161 },
            { value: "Energy Guide", count: 151 },
            { value: "Product Improvement Bulletin", count: 142 },
            { value: "Fits and Clearances Manuals", count: 108 },
            { value: "Industrial Repair Information Letters (IRIL)", count: 77 },
            { value: "Standard Practice Manual (SPM)", count: 77 },
            { value: "Tool Kit", count: 67 },
            { value: "Test Schedules Engine", count: 65 },
            { value: "Product Safety Warning", count: 58 },
            { value: "Special Inspection Procedures", count: 53 },
            { value: "Product Breakdown Structures (PBS)", count: 28 },
            { value: "OMAT", count: 27 },
            { value: "Installation Design Manual", count: 17 },
            { value: "Operation Maintenance Manual (OMM)", count: 15 },
            { value: "Asset Management Report", count: 12 },
            { value: "Transmittal Letter", count: 11 },
            { value: "Overhaul Manuals", count: 10 },
            { value: "Ilustrated Parts Catalog (IPC)", count: 9 },
            { value: "EMP", count: 7 },
            { value: "Inspection and Test Plans", count: 4 },
            { value: "Component Identification Aids", count: 2 },
            { value: "Test Schedules Rig", count: 2 },
            { value: "Repair Notes", count: 1 },
            { value: "Unknown Document Type", count: 1 },
        ],
    },
};
